import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { DragDropModule } from '@angular/cdk/drag-drop';

import { FocusOnCreateDirective } from './others/directives/focus-on-create.directive';
import { MustMatchDirective } from './others/directives/must-match.directive';
import { AlreadyTakenDirective } from './others/directives/already-taken.directive';
import { CopyClipboardDirective } from './others/directives/copy-clipboard.directive';
import { LicenseCheckDirective } from './others/directives/license-check.directive';
import { DurationFormatPipe } from './others/pipes/duration-format.pipe';
import { ObjectToArrayPipe } from './others/pipes/object-to-array.pipe';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgSelectModule } from '@ng-select/ng-select';
import { TagInputModule } from 'ngx-chips';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoggerModule } from 'ngx-logger';
import { FlashMessagesModule } from '@mobilestar/ngx-flash-messages';
import { NgDatepickerModule } from 'ng2-datepicker';

import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireFunctionsModule } from '@angular/fire/functions';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireStorageModule } from '@angular/fire/storage';

import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { MainComponent } from './components/main/main.component';
import { NavbarComponent } from './components/main/navbar/navbar.component';
import { SidebarComponent } from './components/main/sidebar/sidebar.component';
import { DashboardComponent } from './components/main/content/dashboard/dashboard.component';
import { InfoBoxesComponent } from './components/main/content/dashboard/info-boxes/info-boxes.component';
import { AccountListComponent } from './components/main/content/accounts/account-list/account-list.component';
import { AccountDetailsComponent } from './components/main/content/accounts/account-details/account-details.component';

import { NotFoundComponent } from './components/others/not-found/not-found.component';
import { ModalComponent } from './components/others/modal/modal.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ThirdPartiesComponent } from './components/main/content/third-parties/third-parties.component';
import { OpentokDetailsComponent } from './components/main/content/third-parties/opentok-details/opentok-details.component';
import { AzureDetailsComponent } from './components/main/content/third-parties/azure-details/azure-details.component';
import { ProceedingDetailsComponent } from './components/main/content/third-parties/proceeding-details/proceeding-details.component';
import { SettingsComponent } from './components/main/content/settings/settings.component';
import { FeatureUpdatesComponent } from './components/main/content/feature-updates/feature-updates.component';
import { DownloadsConfigComponent } from './components/main/content/downloads-config/downloads-config.component';
import { UsageReportsComponent } from './components/main/content/usage-reports/usage-reports.component';
import { ForceUpdateComponent } from './components/main/content/force-update/force-update.component';
import { WhitelabelsComponent } from './components/main/content/whitelabels/whitelabels.component';

@NgModule({
  declarations: [
    FocusOnCreateDirective,
    MustMatchDirective,
    AlreadyTakenDirective,
    CopyClipboardDirective,
    LicenseCheckDirective,
    DurationFormatPipe,
    ObjectToArrayPipe,
    AppComponent,
    LoginComponent,
    NavbarComponent,
    MainComponent,
    SidebarComponent,
    DashboardComponent,
    InfoBoxesComponent,
    AccountListComponent,
    AccountDetailsComponent,
    NotFoundComponent,
    ModalComponent,
    ThirdPartiesComponent,
    OpentokDetailsComponent,
    AzureDetailsComponent,
    ProceedingDetailsComponent,
    SettingsComponent,
    FeatureUpdatesComponent,
    DownloadsConfigComponent,
    UsageReportsComponent,
    ForceUpdateComponent,
    WhitelabelsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgSelectModule,
    TagInputModule,
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    CarouselModule.forRoot(),
    ProgressbarModule.forRoot(),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    }),
    FlashMessagesModule.forRoot(),
    NgDatepickerModule,
    LoggerModule.forRoot({
      level: environment.logger.level,
      serverLoggingUrl: environment.logger.serverLoggingUrl,
      serverLogLevel: environment.logger.serverLogLevel
    }),
    AngularFireModule.initializeApp(environment.firebase, environment.firebase.projectId),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  entryComponents: [
    AccountDetailsComponent
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}